

import React from "react";
import { connect } from 'react-redux'

import { getStep } from '../../utils'
import { setStep } from '../../api/gui/actions'
import ErrorBoundary from "../../components/error-boundary";
import BreadCrumbs from "../../components/breadcrumbs";

import { getStepOrder } from '../../../app/constants'

class StepRenderer extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        let navType = performance.navigation.type
        if (navType === 1) {
            this.props.history.push('/step/0')
        }
    }

    componentDidUpdate() {
        let STEP_ORDER = getStepOrder(this.props.offers.offerQueryParameters);

        if (STEP_ORDER[+this.props.match.params.stepnumber]  !== this.props.gui.currentStep) {
            this.props.dispatch(setStep(STEP_ORDER[+this.props.match.params.stepnumber]))
        }
    }

    
    render() {
        let STEP_ORDER = getStepOrder(this.props.offers.offerQueryParameters)

        let StepComponent = getStep(STEP_ORDER[+this.props.match.params.stepnumber || 0 ])
        
        return (
            <ErrorBoundary>
                <BreadCrumbs />
                <StepComponent {...this.props} />
            </ErrorBoundary>
        )
    }
}


function mapStateToProps(state) {

    var f = {
        gui: {},
        offers: {},
    }
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.offers = (state.offers === undefined) ? {} : state.offers

    return f;
}

export default connect(mapStateToProps)(StepRenderer);
